export const FETCH_USER_DEPT_REQUEST = '@userDept/FETCH_USER_DEPT_REQUEST';
export const FETCH_USER_DEPT_SUCCESS = '@userDept/FETCH_USER_DEPT_SUCCESS';
export const FETCH_USER_DEPT_FAILURE = '@userDept/FETCH_USER_DEPT_FAILURE';
